import { Edit, useForm } from "@refinedev/antd";
import { Form, Input } from "antd";

import { BlockedUrlUpdate } from "interfaces";


export const BlockedUrlEdit: React.FC = () => {
  const { formProps, saveButtonProps } = useForm<BlockedUrlUpdate>();

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="URL"
          name="url"
          extra="Схема, query string и завершающий слеш при сохранении удаляются"
          rules={[{ required: true, message: "Укажите URL" }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Edit>
  );
};
